package com.rosario.juridico.domain

import kotlinx.serialization.Serializable
import kotlinx.serialization.json.Json
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.withContext
import kotlinx.coroutines.sync.Mutex
import kotlinx.coroutines.sync.withLock
import juridico5.composeapp.generated.resources.Res
import org.jetbrains.compose.resources.ExperimentalResourceApi

@Serializable
data class Dependencia(
    val id: String,
    val nombre: String,
    val direccion: String,
    val telefonos: List<String> = emptyList(),
    val email: String = "",
    val categoria: String = "",
    val descripcion: String = "",
    val search_key: String = ""
)

object DependenciaRepository {
    private val json = Json { ignoreUnknownKeys = true }
    private var cachedDependencias: List<Dependencia> = emptyList()
    private val mutex = Mutex()

    /**
     * Carga y normaliza los datos una sola vez.
     */
    @OptIn(ExperimentalResourceApi::class)
    suspend fun getDependencias(): List<Dependencia> = mutex.withLock {
        if (cachedDependencias.isNotEmpty()) return@withLock cachedDependencias

        return withContext(Dispatchers.Default) {
            try {
                val bytes = Res.readBytes("files/dependencias_publicas.json")
                val content = bytes.decodeToString()
                val list = json.decodeFromString<List<Dependencia>>(content)
                cachedDependencias = list
                list
            } catch (e: Exception) {
                println("Error cargando dependencias_publicas.json: ${e.message}")
                emptyList()
            }
        }
    }

    /**
     * Buscador optimizado que utiliza exclusivamente el campo search_key.
     */
    suspend fun buscar(query: String): List<Dependencia> {
        val dependencias = getDependencias()
        if (query.isBlank()) return dependencias

        val normalizedQuery = query.unaccent().lowercase()
        val terms = normalizedQuery.split(" ").filter { it.length > 1 }

        return withContext(Dispatchers.Default) {
            dependencias.filter { dep ->
                // Filtrado por search_key (ya normalizado en el JSON)
                terms.all { term -> dep.search_key.contains(term) }
            }
        }
    }

    private fun String.unaccent(): String {
        val accents = "áéíóúüñÁÉÍÓÚÜÑ"
        val noAccents = "aeiouunAEIOUUN"
        return this.map { char ->
            val index = accents.indexOf(char)
            if (index >= 0) noAccents[index] else char
        }.joinToString("")
    }
}
